import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { editUserRole } from 'api/administration/roles/Edit'

async function updateRole({ userId, user }: any) {
  return await editUserRole(userId, user)
}

function* participantEditRoleEffectSaga(action: any) {
  try {
    yield call(updateRole, action.payload)
    yield put(fromActions.Actions.participantGetRoleById(action.payload.userId))
    yield put(fromActions.Actions.participantGet(action.payload.userId))
    SuccessToast(I18n.t('administration.toastMessages.editRoleSuccess'))
  } catch (error) {
    ErrorToast(I18n.t(`administration.toastMessages.genericError`))
    console.log('error: ', error)
  }
}

export function* participantEditRoleWatcherSaga() {
  yield takeLatest(fromActions.PARTICIPANT_EDIT_ROLE, participantEditRoleEffectSaga)
}
